export const
  url = {
  loginUser: 'login',
  userSettings: 'me',
  getVerificationCode: 'verifyEmail',
  checkEmailCode: 'checkEmailCode',
  uploadPassport: 'uploadPassport',
  updateUserSettings: 'updateUserSettings',
  tradeSymbols: 'getSymbolsWithPrice',
  investmentIdeas: 'investmentIdeas',
  investmentIdea: 'investmentIdea',

  searchStocks: 'search',

  userSupportInquiry: 'user/contactSupport',
  transactionHistory: 'user/transaction/history',
  agreeConditions: 'user/agreeConditions',
  advancePayment: 'user/createAdvancedPayment',
  userWithdraw: 'user/withdrawRequest ',
  registerUser: 'user/register',
  updateTrading: 'user/updateTrading',
  getUserDocuments: 'user/getDocuments',
  getUserDoc: 'user/getDoc',
  contactDetailByCountry: 'user/contactDetailByCountry',
  getMyTradings: 'user/getMyTradings',
  getMyOrder: 'user/orders',
  cancelOrder: 'user/cancel/order',

  buyOrSellManual: 'symbol/buyOrSell',
  buyOrSellAutomate: 'symbol/automate/buyOrSellLimit',

  customGraphicData: 'user/custom/symbol'
};
